export default class PageIterator {
    /**
     * This function should be added to the constructor with all arguments, except for the identifier
     * of the last object (LastObjId). The LastObjId is appended by the PageIterator when the getNext function is called.
     * The function must return an array of objects. Each object should include an id, which serves as the identifier
     * for loading the next block of objects.
     * @type {function}
     */
    #repositoryFunction = () => {};
    /** @type {string} */
    #lastObjId = '';
    /** @type {boolean} */
    #isLastPage = false;

    /** @param {function} repositoryFunction */
    constructor(repositoryFunction) {
        this.#repositoryFunction = repositoryFunction;
    }

    /** @returns {Promise<*>} */
    async getNext(){
        if (this.#isLastPage)
            return Promise.resolve([])
        const result = await this.#repositoryFunction(this.#lastObjId);
        this.#lastObjId = result.length ? result.at(-1).id : "";
        this.#isLastPage = result.length === 0;
        return result;
    }
}